<template>
  <div data-testid="visualizationAside">
    <splitter-context-helper
      v-if="panel"
      :label="$t('dashboard:panel_data_settings.context.panel', 'Panel')"
      :value="panel.title"
    />
    <cc-error :show="!loading && fatalError" @click="init" />
    <cc-loading :show="loading && !fatalError" />
    <div v-if="!loading && !fatalError" class="col mt-4">
      <cc-expandable-select
        :title="$t('dashboard:edit_page.aside.tabs.panel_visualization.visualization', 'Visualization')"
        :expanded.sync="visTypeExpanded"
        data-testid="visualizationTypeOpts"
      >
        <div slot="toggle-switch">
        </div>
        <div class="vis-content">
          <cc-form-input
            labelFor="filter"
            :label="$t('common:single_word.filter', 'Filter')"
            data-testid="txtFilterVis"
            label-cols="2"
            content-cols
          >
            <b-form-input id="filter"
              v-model="searchFilter"
              autocomplete="off"
              :placeholder="_searchPlaceholder"
            ></b-form-input>
          </cc-form-input>

          <div class="vis-buttons">
            <span v-for="vis in visualizationTypes"
              v-bind:key="vis.id"
            >
              <span
                class="vis-btn"
                v-on:click="formDisabled ? '' : currentVis = vis.id"
                v-bind:class="{selected : currentVis == vis.id, disabled : formDisabled}"
                :id="vis.id + '-btn'"
                :data-testid="'btn' + vis.id"
              >
                <div v-html="vis.html">
                </div>
                <div>
                  {{vis.name}}
                </div>
              </span>
              <b-tooltip :target="vis.id + '-btn'" triggers="hover">
                {{vis.description}}
              </b-tooltip>
            </span>

          </div>
        </div>
      </cc-expandable-select>
      
      <!-- VISUALIZATION OPTIONS -->
      <cc-expandable-select v-if="!optionsToHide['display']"
        :title="$t(`explore_app:visualization_options.display.title`, `Display`)"
        data-testid="displayOpts">
        <div slot="toggle-switch">
        </div>
        <div class="exp-select-body">
          <b-form-group
            label-cols="5"
            :label="$t(`explore_app:visualization_options.display.form.title.label`, `Title:`)">
            <b-form-input type="text" v-model="vis_opts.display.title" maxlength="125"
              :disabled="formDisabled"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols="5"
            :label="$t(`explore_app:visualization_options.display.form.subtitle.label`, `Subtitle:`)">
            <b-form-input type="text" v-model="vis_opts.display.subtitle" maxlength="125"
              :disabled="formDisabled"></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols="5"
            :label="$t(`explore_app:visualization_options.display.form.show_legend.label`, `Show Legend:`)">
            <b-form-checkbox v-model="vis_opts.display.showLegend" switch size="lg" data-testid="cboShowLegend"
              :disabled="formDisabled"></b-form-checkbox>
          </b-form-group>
          <b-form-group
            v-if="currentVis === 'depth_chart'"
            label-cols="5"
            :label="$t(`explore_app:visualization_options.display.form.toggle_change_over_time.label`, `Toggle change over time:`)">
            <b-form-checkbox v-model="vis_opts.display.toggleChangeOverTime" switch size="lg"
              :disabled="formDisabled"></b-form-checkbox>
          </b-form-group>
        </div>
      </cc-expandable-select>

      <cc-expandable-select v-if="!optionsToHide['leftAxis']"
        :title="$t(`explore_app:visualization_options.left_axis.title`, `Left Axis`)"
        data-testid="leftAxisOpts">
        <div slot="toggle-switch">
        </div>
        <div class="exp-select-body">
          <b-form-group
            label-cols="5"
            :label="$t(`explore_app:visualization_options.y_axis.form.show.label`, `Show:`)">
            <b-form-checkbox v-model="vis_opts.leftAxis.show" switch size="lg"
              :disabled="formDisabled"></b-form-checkbox>
          </b-form-group>
          <b-form-group
            label-cols="5"
            :label="$t(`explore_app:visualization_options.y_axis.form.minimum.label`, `Min:`)">
            <b-form-input type="number" v-model="vis_opts.leftAxis.min" :placeholder="$t('common:single_word.auto', 'auto')"
              :disabled="formDisabled"></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols="5"
            :label="$t(`explore_app:visualization_options.y_axis.form.maximum.label`, `Max:`)">
            <b-form-input type="number" v-model="vis_opts.leftAxis.max" :placeholder="$t('common:single_word.auto', 'auto')"
              :disabled="formDisabled"></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols="5"
            :label="$t(`explore_app:visualization_options.y_axis.form.axis_label.label`, `Label:`)">
            <b-form-input type="text" v-model="vis_opts.leftAxis.label"
              :disabled="formDisabled"></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols="5"
            :label="$t(`explore_app:visualization_options.y_axis.form.align_label.label`, `Align Label:`)">
            <b-form-select v-model="vis_opts.leftAxis.alignLabel" :options="labelAlignmentOptions"
              :disabled="formDisabled"></b-form-select>
          </b-form-group>
        </div>
      </cc-expandable-select>

      <!-- HIDE RIGHT AXIS, CANT BE USED CURRENTLY -->
      <!-- <cc-expandable-select v-if="!optionsToHide['rightAxis']"
        :title="$t(`explore_app:visualization_options.right_axis.title`, `Right Axis`)"
        data-testid="rightAxisOpts">
        <div slot="toggle-switch">
        </div>
        <div class="exp-select-body">
          <b-form-group
            label-cols="5"
            :label="$t(`explore_app:visualization_options.y_axis.form.show.label`, `Show:`)">
            <b-form-checkbox v-model="vis_opts.rightAxis.show" switch size="lg"
              :disabled="formDisabled"></b-form-checkbox>
          </b-form-group>
          <b-form-group
            label-cols="5"
            :label="$t(`explore_app:visualization_options.y_axis.form.minimum.label`, `Min:`)">
            <b-form-input type="number" v-model="vis_opts.rightAxis.min" :placeholder="$t('common:single_word.auto', 'auto')"
              :disabled="formDisabled"></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols="5"
            :label="$t(`explore_app:visualization_options.y_axis.form.maximum.label`, `Max:`)">
            <b-form-input type="number" v-model="vis_opts.rightAxis.max" :placeholder="$t('common:single_word.auto', 'auto')"
              :disabled="formDisabled"></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols="5"
            :label="$t(`explore_app:visualization_options.y_axis.form.axis_label.label`, `Label:`)">
            <b-form-input type="text" v-model="vis_opts.rightAxis.label"
              :disabled="formDisabled"></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols="5"
            :label="$t(`explore_app:visualization_options.y_axis.form.align_label.label`, `Align Label:`)">
            <b-form-select v-model="vis_opts.rightAxis.alignLabel" :options="labelAlignmentOptions"
              :disabled="formDisabled"></b-form-select>
          </b-form-group>
        </div>
      </cc-expandable-select> -->

      <cc-expandable-select v-if="!optionsToHide['xAxis']"
        :title="$t(`explore_app:visualization_options.x_axis.title`, `X Axis`)"
        data-testid="xAxisOpts">
        <div slot="toggle-switch">
        </div>
        <div class="exp-select-body">
          <b-form-group
            label-cols="5"
            :label="$t(`explore_app:visualization_options.x_axis.form.show.label`, `Show:`)">
            <b-form-checkbox v-model="vis_opts.xAxis.show" switch size="lg"
              :disabled="formDisabled"></b-form-checkbox>
          </b-form-group>
        </div>
      </cc-expandable-select>

      <cc-expandable-select v-if="!optionsToHide['thresholdLines']"
        :title="$t(`explore_app:visualization_options.threshold_lines.title`, `Threshold Lines`)"
        data-testid="thresholdOpts">
        <div slot="toggle-switch">
        </div>
        <cc-expandable-select v-for="(thresholdLine, index) of vis_opts.thresholdLines" :key="index"
          :title="`Line ${index + 1}`">
          <div slot="toggle-switch">
          </div>
          <div class="exp-select-body">
            <b-form-group
              label-cols="5"
              :label="$t(`explore_app:visualization_options.threshold_lines.form.vis_opts.label`, `Value:`)">
              <b-form-input type="number" v-model="thresholdLine.value"
              :disabled="formDisabled"></b-form-input>
            </b-form-group>
            <b-form-group
              label-cols="5"
              :label="$t(`explore_app:visualization_options.threshold_lines.form.color.label`, `Color:`)">
              <b-form-input type="color" v-model="thresholdLine.color"
              :disabled="formDisabled"></b-form-input>
            </b-form-group>
            <b-form-group
              label-cols="5"
              :label="$t(`explore_app:visualization_options.threshold_lines.form.size.label`, `Size:`)">
              <b-form-select v-model="thresholdLine.size" :options="thresholdLineSizeOptions"
              :disabled="formDisabled"></b-form-select>
            </b-form-group>
            <b-form-group
              label-cols="5"
              :label="$t(`explore_app:visualization_options.threshold_lines.form.delete_line.label`, `Delete Line:`)">
              <div style="text-align: right;">
                <b-button variant="danger" @click="deleteThresholdLine(index)"
              :disabled="formDisabled"><i class="fa fa-times"></i></b-button>
              </div>
            </b-form-group>
          </div>
        </cc-expandable-select>
        <div style="text-align: center;">
          <b-button variant="success" @click="addThresholdLine"
            :disabled="formDisabled">
            <i class="fa fa-plus"></i>
            {{ $t('explore_app:visualization_options.threshold_lines.form.add_line.label', 'Add Line') }}
          </b-button>
        </div>
      </cc-expandable-select>

      <cc-expandable-select v-if="!optionsToHide['gauge']"
        :title="$t(`explore_app:visualization_options.gauge.title`, `Gauge Options`)"
        data-testid="gaugeOpts">
        <div slot="toggle-switch">
        </div>
        <div class="exp-select-body">
          <b-form-group
            label-cols="5"
            :label="$t(`explore_app:visualization_options.gauge.form.minimum.label`, `Min:`)">
            <b-form-input type="number" v-model="vis_opts.gauge.min" placeholder="0"
              :disabled="formDisabled"></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols="5"
            :label="$t(`explore_app:visualization_options.gauge.form.maximum.label`, `Max:`)">
            <b-form-input type="number" v-model="vis_opts.gauge.max" placeholder="100"
              :disabled="formDisabled"></b-form-input>
          </b-form-group>
        </div>
      </cc-expandable-select>

      <cc-expandable-select v-if="!optionsToHide['indicator']"
        :title="$t(`explore_app:visualization_options.indicator.title`, `Indicator`)"
        data-testid="indicatorOpts">
        <div slot="toggle-switch">
        </div>
        <div class="exp-select-body">
          <b-form-group
            label-cols="5"
            :label="$t(`explore_app:visualization_options.indicator.form.direction.label`, `Mode:`)">
            <b-form-select v-model="vis_opts.indicator.direction" :options="indicatorDirectionOptions"
              :disabled="formDisabled"></b-form-select>
          </b-form-group>
          <b-form-group
            label-cols="5"
            :label="$t(`explore_app:visualization_options.indicator.form.show_vis_opts.label`, `Show Value:`)">
            <b-form-checkbox v-model="vis_opts.indicator.showValue" switch size="lg"
              :disabled="formDisabled"></b-form-checkbox>
          </b-form-group>
          <div :style="`display: flex; flex-direction: ${(vis_opts.indicator.direction === 'asc' ? 'column-reverse' : 'column')};`">
            <div style="display: flex; flex-direction: row; margin-bottom: 10px; align-items: center;">
              <b-form-input class="simple-color-picker" type="color" v-model="vis_opts.indicator.baseColor"
              :disabled="formDisabled"></b-form-input>
              <div>{{$t('dashboard:edit_page.aside.tabs.panel_visualization.base_color', 'Base Color')}}</div>
            </div>
            <div v-for="(threshold, index) of vis_opts.indicator.thresholds" :key="index"
              style="display: flex; flex-direction: row; margin-bottom: 10px; align-items: center;">
              <b-form-input class="simple-color-picker" type="color" v-model="threshold.color"
              :disabled="formDisabled"></b-form-input>
              <div style="flex: 0 0; white-space: nowrap; margin-right: 10px;">
                {{ vis_opts.indicator.direction === 'asc' ? 
                  $t('dashboard:edit_page.aside.tabs.panel_visualization.greater_than', 'when greater than') : 
                  $t('dashboard:edit_page.aside.tabs.panel_visualization.less_than','when less than') }}
              </div>
              <b-form-input
                type="number"
                v-model="threshold.value"
                :disabled="formDisabled"
              ></b-form-input>
              <b-button
                variant="danger"
                style="margin-left: 10px;"
                @click="removeIndicatorThreshold(index)"
                :disabled="formDisabled"
              >
                X
              </b-button>
            </div>
            <div style="text-align: center; padding: 10px;">
              <b-button variant="success" @click="addIndicatorThreshold"
                :disabled="formDisabled">
                <i class="fa fa-plus"></i>
                {{ $t('explore_app:visualization_options.indicator.form.add_threshold.label', 'Add Threshold') }}
              </b-button>
            </div>
          </div>
        </div>
      </cc-expandable-select>

    </div>
  </div>
</template>

<script>
import VISUALIZATION_TYPES from '@/shared/visualization-types';
import SplitterContextHelper from '@/components/SplitterContextHelper';

const THRESHOLD_LINE_DEFAULT = {
  value: 0,
  color: '#c23632',
  size: 2,
};


export default {
  name: 'visualization-aside',
  components: {
    SplitterContextHelper
  },
  props: {
    saveTrigger: {
      type: Boolean
    },
    panel: {
      type: Object
    }
  },
  data() {
    return {
      loading: true,
      fatalError: false,
      formDisabled: true,
      currentVis: '',
      searchFilter: '',
      visTypeExpanded: true,
      saveTriggered: false,

      // Visualization Options
      thresholdLineSizeOptions: [
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
      ],
      indicatorDirectionOptions: [
        { value: 'asc', text: this.$t('common:single_word.ascending','Ascending') },
        { value: 'desc', text: this.$t('common:single_word.descending','Descending') },
      ],
      vis_opts: {
        display: {},
        leftAxis: {},
        rightAxis: {},
        thresholdLines: [],
        gauge: {},
        indicator: {},
        xAxis: {}
      },

      defaults : {
        display: {
          title: '',
          subtitle: '',
          showLegend: true,
          toggleChangeOverTime: false, // for the depth chart
        },
          leftAxis: {
          min: '',
          max: '',
          label: '',
          show: true,
          alignLabel: 'end',
        },
        rightAxis: {
          min: '',
          max: '',
          label: '',
          show: false,
          alignLabel: 'end',
        },
        xAxis: {
          show: true,
        },
      }
    };
  },
  computed: {
    visualizationTypes() {
      let visTs = VISUALIZATION_TYPES.map(e => {
        return {
          id: e.id,
          html: e.carouselHTML,
          name: this.$t(e.name.translationKey, e.name.fallback),
          description: this.$t(e.description.translationKey, e.description.fallback)
        };
      });

      if (this.searchFilter != '') {
        let filter = this.searchFilter.toLowerCase();
        visTs = visTs.filter(e => e.id.toLowerCase().includes(filter) ||
          e.name.toLowerCase().includes(filter) || 
          e.description.toLowerCase().includes(filter));
      }

      return visTs
    },
    _searchPlaceholder(){
      return this.$t('dashboard:edit_page.aside.tabs.panel_visualization.filter_visualization','Type to filter visualization types');
    },
    optionsToHide() {
      const currentVisualization = VISUALIZATION_TYPES.find(e => e.id === this.currentVis);

      const hide = {};
      for (let group of currentVisualization.hideVisualizationOptions) {
        hide[group] = true;
      }

      return hide;
    },
    labelAlignmentOptions() {
      return [
        { value: 'end', text: this.$t('explore_app:visualization_options.label_alignment.end', 'Top') },
        { value: 'center', text: this.$t('explore_app:visualization_options.label_alignment.center', 'Center') },
      ];
    },

  },
  watch: {
    saveTrigger(newValue, oldValue) {
      if (newValue === true) {

        const validationResult = this.validate();

        if (!validationResult.error) {
          let visualizationOptions = {};
          if (!this.optionsToHide.display) visualizationOptions.display = {
            ... this.defaults.display,
            ...this.vis_opts.display
          };
          if (!this.optionsToHide.leftAxis) visualizationOptions.leftAxis = {
            ... this.defaults.leftAxis,
            ...this.vis_opts.leftAxis
          };
          if (!this.optionsToHide.rightAxis) visualizationOptions.rightAxis = {
            ... this.defaults.rightAxis,
            ...this.vis_opts.rightAxis
          };
          if (!this.optionsToHide.thresholdLines) visualizationOptions.thresholdLines = [
            ...this.vis_opts.thresholdLines
          ];
          if (!this.optionsToHide.gauge) visualizationOptions.gauge = {
            ...this.vis_opts.gauge
          };
          if (!this.optionsToHide.indicator) visualizationOptions.indicator = {
            ...this.vis_opts.indicator
          };
          if (!this.optionsToHide.xAxis) visualizationOptions.xAxis = {
            ... this.defaults.xAxis,
            ...this.vis_opts.xAxis
          };

          this.saveTriggered = true;

          this.$emit('visualization-updated', {
            type: this.currentVis,
            options: visualizationOptions,
          });
        } else {
          this.$Toastr = {
            type: "error",
            message: validationResult.error,
          };
        }

        this.$emit('update:save-trigger', false);
      }
    },
    panel() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    validate() {
      const result = { error: null };

      if (this.vis_opts.leftAxis.min &&
        this.vis_opts.leftAxis.max &&
        Number(this.vis_opts.leftAxis.max) <= Number(this.vis_opts.leftAxis.min)) {
        result.error = "Axis max must be greater than axis min."
      }

      return result;
    },
    async init() {
      this.loading = true;
      this.fatalError = false;

      this.formDisabled = !this.$s.can.access('dashboard..entity.update');

      if (this.saveTriggered) {
        this.saveTriggered = false;
      } else {
        this.visTypeExpanded = true;
      }

      this.currentVis = this.panel.visualization && 
      this.panel.visualization.type ? 
        this.panel.visualization.type : 
        this.visualizationTypes[0].id;

      this.vis_opts = {
        display: {},
        leftAxis: {},
        rightAxis: {},
        thresholdLines: [],
        gauge: {},
        indicator: {},
        xAxis: {}
      };

      if (this.panel && this.panel.visualization && this.panel.visualization.options) {
        this.vis_opts = {...this.vis_opts, ...JSON.parse(JSON.stringify(this.panel.visualization.options))};
      }

      this.loading = false;
    },
    emitHeight() {
      this.$emit('heightChanged', this.$el.offsetHeight);
    },
    addThresholdLine() {
      this.vis_opts.thresholdLines.push(JSON.parse(JSON.stringify(THRESHOLD_LINE_DEFAULT)));
    },
    deleteThresholdLine(index) {
      this.vis_opts.thresholdLines.splice(index, 1);
    },
    addIndicatorThreshold() {
      let newValue = 100;

      if (!this.vis_opts.indicator.thresholds) this.vis_opts.indicator.thresholds = [];

      if (this.vis_opts.indicator.thresholds.length) {
        const lastValue = this.vis_opts.indicator.thresholds.slice(-1)[0];

        if (!isNaN(lastValue.value)) {
          newValue = Number(lastValue.value) + 10 * (this.vis_opts.indicator.direction === 'asc' ? 1 : -1);
        }
      }

      this.vis_opts.indicator.thresholds.push({ color: '#000000', value: newValue });
      this.vis_opts.indicator = {
        ...this.vis_opts.indicator
      };
    },


  }
};
</script>

<style>
.btn-row .btn {
    margin: 0 1em;
}

.vis-buttons {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  /* padding: 1rem; */
}

.vis-btn {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: .5rem;
}

.vis-btn.selected {
  border: .2rem rgb(98,155,228) solid;
  border-radius: 7%;
}

.vis-content {
  padding: .5rem;
}

.exp-select-body {
  padding: .5rem;
}

.vis-btn.disabled {
  cursor: not-allowed;
}
</style>
